import { http } from "@canvas/api";

export interface GetCmsProductSKUsReq {
  endpoint: "cmsapi.v2.products.:productId.skus";
  productId: string | number;
  query?: string;
}

export interface GetCmsProductSKUsRes {
  [key: string]: any;
}

// interface SkuDetails {
//   id: number;
//   code: string;
//   product_id: number;
//   display_name: string;
// }

export function get(req: GetCmsProductSKUsReq): Promise<GetCmsProductSKUsRes> {
  return http
    .GET(`/cmsapi/v2/products/${req.productId}/skus?${req.query}`)
    .then((response: GetCmsProductSKUsRes) => {
      // validate response here
      return response;
    })
    .catch(err => {
      return Promise.reject(err);
    });
}
